import React from 'react';
import { Panel, Col, Row, Table } from 'react-bootstrap';

import ProfessionalValidation from '../validation/professionalValidation';
import {
  degreeLevels,
  licenseTypes,
  certificateTypes,
  statusTypes
} from "../config/constants";

const ProfessionalSummary = (props) => {
  const withoutValidation = props.withoutValidation;
  const validationStatus = new ProfessionalValidation(props.colleges).getValidationStatus(props);
  const licenseWorkHours = props.workExperience.license.hasWorkHours;
  const certificateWorkHours = props.workExperience.certificate.hasWorkHours;
  const colleges = {};
  props.colleges.forEach(college => colleges[college.id] = college.name);
  const renderDegrees = () => {
    if(props.degrees.length < 1)
      return <p>No Degrees Entered</p>;

    return (
      <Table striped>
        <thead>
        <tr>
          <th>Name</th>
          <th>Level</th>
          <th>School</th>
          <th>Date Received</th>
          <th>Delta Applied (Pending)</th>
        </tr>
        </thead>
        <tbody>
        {
          props.degrees.map (
            (degree, index) => (
              <tr key={index}>
                <td>{degree.name}</td>
                <td>{degreeLevels[degree.level]}</td>
                <td>{colleges[degree.school]}</td>
                <td>{degree.date}</td>
                <td>{degree.deltaApplied ? 'Yes' : ''}</td>
              </tr>
            )
          )
        }
        </tbody>
      </Table>
    )
  };

  const renderLicenses = () => {
    if(props.licenses.length < 1)
      return <p>No Licenses Entered</p>;

    return (
      <Table striped>
        <thead>
        <tr>
          <th>Type</th>
          <th>Number</th>
          <th>Expiration</th>
        </tr>
        </thead>
        <tbody>
        {
          props.licenses.map (
            (license, index) => (
              <tr key={index}>
                <td>{licenseTypes[license.type]}</td>
                <td>{license.number}</td>
                <td>{license.expirationDate}</td>
              </tr>
            )
          )
        }
        </tbody>
      </Table>
    )
  };

  const renderCertificates = () => {
    if(props.certificates.length < 1)
      return <p>No Certificates Entered</p>;

    return (
      <Table striped>
        <thead>
        <tr>
          <th>Type</th>
          <th>Number</th>
          <th>Expiration</th>
        </tr>
        </thead>
        <tbody>
        {
          props.certificates.map (
            (certificate, index) => (
              <tr key={index}>
                <td>{certificateTypes[certificate.type]}</td>
                <td>{certificate.number}</td>
                <td>{certificate.expirationDate}</td>
              </tr>
            )
          )
        }
        </tbody>
      </Table>
    )
  };

  return(
    <Panel className="professional-info-panel" header="Professional Information" bsStyle={withoutValidation ? statusTypes.INFO : validationStatus.section.status}>
      <Row>
        <Col md={6}>
          <h3 className="summary-sub-category">Degrees</h3>
          {renderDegrees()}
        </Col>
        <Col md={6}>
          <h3 className="summary-sub-category">Licenses</h3>
          {renderLicenses()}
          <dl className="dl-horizontal">
            <dt>1000+ Work Hours</dt>
            <dd>{licenseWorkHours ? 'Yes' : 'No'}</dd>
            {
              licenseWorkHours &&
              <React.Fragment>
                <dt>Employer</dt>
                <dd>{props.workExperience.license.employer}</dd>
              </React.Fragment>
            }
          </dl>
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <h3 className="summary-sub-category">Certificates</h3>
          {renderCertificates()}
          <dl className="dl-horizontal">
            <dt>1000+ Work Hours</dt>
            <dd>{certificateWorkHours ? 'Yes' : 'No'}</dd>
            {
              certificateWorkHours &&
              <React.Fragment>
                <dt>Employer</dt>
                <dd>{props.workExperience.certificate.employer}</dd>
              </React.Fragment>
            }
          </dl>
        </Col>
        <Col md={6}>
          <h3 className="summary-sub-category">Other Professional</h3>
          <dl>
            <dt>Other license or certificate</dt>
            <dd>{props.otherLicenseOrCert.hasOtherLicenseOrCert ? 'Yes' : 'No'}</dd>
            {
              props.otherLicenseOrCert.hasOtherLicenseOrCert &&
              <React.Fragment>
                <dt>License/Certificate</dt>
                <dd>{props.otherLicenseOrCert.name}</dd>
              </React.Fragment>
            }
            <dt>Work Experience with patient care > 1000 hours</dt>
            <dd>{props.hasOtherWorkHours ? 'Yes' : 'No'}</dd>
            <dt>Volunteer Experience with patient care > 200 hours</dt>
            <dd>{props.hasVolunteerHours ? 'Yes' : 'No'}</dd>
          </dl>
        </Col>
      </Row>
    </Panel>
  );
};

export default ProfessionalSummary;